// extracted by mini-css-extract-plugin
export var compactFilters = "_ft-4";
export var detailImage = "_ft-1";
export var dropdownContainer = "_ft-2";
export var imageContainer = "_ft-0";
export var selectedCard = "_ft-3";